import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";
import Cal, { getCalApi } from "@calcom/embed-react";
import "./ContactSection.css";

const ContactSection = () => {
  const [copiedNumber, setCopiedNumber] = useState(null);

  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "30min" });
      cal("ui", { hideEventTypeDetails: false, layout: "week_view" });
    })();
  }, []);

  const copyToClipboard = async (number) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(number);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = number;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopiedNumber(number);
      setTimeout(() => setCopiedNumber(null), 2000);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <section id="contact" className="contact-section py-5">
      <Container>
        <Row className="align-items-start fade-in-section">
          {/* ---------- LEFT: CONTACT DETAILS ---------- */}
          <Col lg={6} md={12} className="mb-5 mb-lg-0">
            <h2 className="fw-bold mb-4 text-left">
              Ready to Transform Your Home?
            </h2>
            <p className="mb-5 text-muted text-left">
              Partner with Ontario Home Renovation for all your home improvement
              needs. Our dedicated team is ready to discuss your specific
              requirements, answer your questions, and provide a complimentary
              consultation to make your home beautiful and functional.
            </p>

            <Card className="contact-card p-5 shadow-modern border-0">
              <Card.Body>
                {/* ---------- Phone Section ---------- */}
                <div className="contact-item mb-4">
                  <MdPhone className="contact-icon phone" />
                  <div className="contact-text">
                    <p className="mb-1">
                      <strong>Call Us</strong>
                    </p>
                    <p>
                      <span
                        className="phone-link position-relative"
                        onClick={() => copyToClipboard("416 818 6865")}
                      >
                        416 818 6865
                        {copiedNumber === "416 818 6865" && (
                          <span className="copy-tooltip">Copied!</span>
                        )}
                      </span>
                      <br />
                      <span
                        className="phone-link position-relative"
                        onClick={() => copyToClipboard("437 236 6214")}
                      >
                        437 236 6214
                        {copiedNumber === "437 236 6214" && (
                          <span className="copy-tooltip">Copied!</span>
                        )}
                      </span>
                    </p>
                  </div>
                </div>

                {/* ---------- Email ---------- */}
                <div className="contact-item mb-4">
                  <MdEmail className="contact-icon email" />
                  <div className="contact-text">
                    <p className="mb-1">
                      <strong>Email</strong>
                    </p>
                    <p>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=onhomereno@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="email-link"
                      >
                        onhomereno@gmail.com
                      </a>
                    </p>
                  </div>
                </div>

                {/* ---------- Location ---------- */}
                <div className="contact-item mb-0">
                  <MdLocationOn className="contact-icon location" />
                  <div className="contact-text">
                    <p className="mb-1">
                      <strong>Our HQ</strong>
                    </p>
                    <p>
                      <a
                        href="https://www.google.com/maps/dir/?api=1&destination=55+Town+Center+Court+Unit+%23700,+Toronto,+ON+M1P+4X4"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="map-link"
                      >
                        55 Town Center Court Unit #700, Toronto, ON M1P 4X4
                      </a>
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ---------- RIGHT: CAL.COM EMBED ---------- */}
          <Col lg={6} md={12}>
            <div className="cal-wrapper shadow-modern p-4 fade-in-section">
              <h3 className="text-center mb-4 fw-semibold text-dark">
                Book a Free Consultation
              </h3>
              <div className="cal-frame-container">
                <Cal
                  namespace="30min"
                  calLink="onhomereno/30min"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    borderRadius: "1.2rem",
                  }}
                  config={{ layout: "week_view" }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;
